import React from 'react';
import clsx from 'clsx';

export interface Props {
  children: React.ReactNode;
  isKiosko?: boolean;
  className?: string;
}

/**
 * Root layout shell that swaps the wrapper markup between the terminal and handheld
 * layouts. Renders in *both* modes — `RootLayout` always mounts it and passes
 * `isKiosko`, so the non-kiosko branch is what the mobile flow uses.
 */
export const LayoutWrapper = ({children, isKiosko = false, className}: Props) => {
  if (!isKiosko) {
    return (
      <div className={clsx(className, 'kiosko:w-full kiosko-h-full')}>{children}</div>
    );
  }

  return (
    <div className={clsx(className)}>
      <div>{children}</div>
    </div>
  );
};
